import appConfigs from '../../config.json';
import { SnackbarOrigin } from '@material-ui/core';
export const MessagePossition: SnackbarOrigin = { vertical: 'top', horizontal: 'center' };
export default {
  getApiConfig: () => {
    return { apiBaseUrl: appConfigs.apiBaseUrl, storageType: appConfigs.storageType };
  },
  getApiConfigForIdentityServer: () => {
    return {
      // apiKey: appConfigs.apiKey,
      apiBaseUrl: appConfigs.apiBaseUrl,
      storageType: appConfigs.storageType,
    };
  },
  getAllConfig: () => {
    return appConfigs;
  },
  getConfig: (key) => {
    for (var keyt in appConfigs) {
    }
    return appConfigs[key];
  },
};
